import * as React from 'react'
import { FC, useMemo } from 'react'
import { BillToMatchDrawerProps } from '../typings'
import { AppAvatar } from '@sales-center/components'
import { SmallLocationCard } from '@user/components/Location'
import { ENTITY_TYPES } from '@sales-center/common'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { getLocationName } from '@user/store/entityLocations'

export const Header: FC<BillToMatchDrawerProps> = (props) => {
  const { entityType, location, styles } = props

  const [expanded, toggleExpanded] = useToggleBoolean()

  const header = useMemo(
    () =>
      `${
        entityType === ENTITY_TYPES.Lead ? 'Lead' : 'Opportunity'
      }: ${getLocationName(location)}`,
    [entityType, location],
  )

  return (
    <Box sx={styles.formTopSection}>
      <Box display="flex" alignItems="center" mb={1}>
        <AppAvatar variant="outlined" text="SC" />
        <Typography sx={styles.label}>{header}</Typography>
      </Box>
      <SmallLocationCard
        {...props}
        open={expanded}
        toggleOpen={toggleExpanded}
        isEditable={false}
      />
    </Box>
  )
}
Header.displayName = 'Header'
